import { useParams, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { Text, View, Flex, Divider, TextField, Table, TableHead, TableRow, TableCell, TableBody, SelectField} from '@aws-amplify/ui-react';
import Loading from '../components/loading';
import { Heading, Button } from '@aws-amplify/ui-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { withFleets } from '../withFleets';

function scannedValue(value, confidence) {
  const shown = value || "—";
  if (!confidence) return shown;
  return `${shown} (${confidence})`;
}

function legibleLabel(value) {
  if (value === 1 || value === true || value === "1") return "Yes";
  if (value === 0 || value === false || value === "0") return "No";
  return "—";
}

export default function Userpersonalinsurancedoc({paramDocKey}) {
  let params = useParams();
  const location = useLocation();
  const pageFleets = new URLSearchParams(location.search).get('fleets');
  let tDocKey = false
  if(paramDocKey)
  {
    tDocKey = paramDocKey;
  } else {
    tDocKey = params.docKey;
  }
  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const [docKey, updateDocKey] = React.useState(tDocKey);
  const [res, updateRes] = useState({status:"If this message stays - email us at info@joinago.com",resp:[]})
  const [is_loading, updateIsLoading] = React.useState(false);
  const [count, setCount] = useState(0);
  const [showDataPacket, updateShowDataPacket] = React.useState(false);
  const [showConfirmFleet, updateShowConfirmFleet] = React.useState(false);
  const [showConfirmDeactivate, updateShowConfirmDeactivate] = React.useState(false);
  const [showConfirmActivate, updateShowConfirmActivate] = React.useState(false);
  const [confirmLanguage, updateConfirmLanguage] = React.useState("");
  const [presignedUrlView, updatePresignedUrlView] = React.useState(false);
  const [showConfirmExpirationDate, updateShowConfirmExpirationDate] = React.useState(false);
  const [showUpdateExpirationDate, updateShowUpdateExpirationDate] = React.useState(false);
  const [insurance_expiration_datetime, updateExpirationDate] = useState(roundBack(new Date(),12));
  const [showConfirmEffectiveDate, updateShowConfirmEffectiveDate] = React.useState(false);
  const [showUpdateEffectiveDate, updateShowUpdateEffectiveDate] = React.useState(false);
  const [insurance_effective_datetime, updateEffectiveDate] = useState(roundBack(new Date(),12));
  const [showSelectCoverageType, updateShowSelectCoverageType] = React.useState(false);
  const [coverageType, updateCoverageType] = React.useState("");
  
  

  async function refreshPage()
  {
    let newCount = count + 1;
    setCount(newCount);
  }

  useEffect(() => {
    const fetchData = async () => {
      updateIsLoading(true)
      let session = await Auth.currentSession()      
      let accessToken = session.getAccessToken()
      let jwt = accessToken.getJwtToken()
      const myInit = {queryStringParameters:{ 
        back_end: process.env.REACT_APP_BACKEND,
        jwt:jwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "insurance",
        request_type: "GET",
        document_name:docKey
      }};
      //console.log(JSON.stringify(myInit))
      try {
          const res = await API.get('adminWebTools','/ago',myInit);
          console.log(JSON.stringify(res))
          updateRes(res);
          updatePresignedUrlView(res["presigned_url_view"]);
          updateIsLoading(false)
          return
      }
      catch (e) {
          const res = {status:"Error retrieving Doc or User not permissioned",resp:[]};
          console.log(JSON.stringify(res))
          updateRes(res);
          updateIsLoading(false)
          return
      }
    }
    fetchData()
  },[count,params])




  const activate = async () => {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt:jwt,
      api_endpoint: "api3:portal:driver_desk",
      section: "insurance",
      request_type: "POST",
      document_name:docKey,
      method: "activate"
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit);
        console.log(JSON.stringify(res))
        //updateRes(res);
        _hideConfirm();
        refreshPage();
        //updateIsLoading(false)
        return
    }
    catch (e) {
        const res = {status:"Error executing request",resp:[]};
        console.log(JSON.stringify(res))
        updateRes(res);
        updateIsLoading(false)
        return
    }
  }


  const deactivate = async () => {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt:jwt,
      api_endpoint: "api3:portal:driver_desk",
      section: "insurance",
      request_type: "POST",
      document_name:docKey,
      method: "deactivate"
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit);
        console.log(JSON.stringify(res))
        //updateRes(res);
        _hideConfirm();
        refreshPage();
        //updateIsLoading(false)
        return
    }
    catch (e) {
        const res = {status:"Error executing request",resp:[]};
        console.log(JSON.stringify(res))
        updateRes(res);
        updateIsLoading(false)
        return
    }
  }


  const signOffFleet = async () => {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt:jwt,
      api_endpoint: "api3:portal:driver_desk",
      section: "insurance",
      request_type: "POST",
      document_name:docKey,
      method: "signofffleet"
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit);
        console.log(JSON.stringify(res))
        //updateRes(res);
        _hideConfirm();
        refreshPage();
        //updateIsLoading(false)
        return
    }
    catch (e) {
        const res = {status:"Error executing request",resp:[]};
        console.log(JSON.stringify(res))
        updateRes(res);
        updateIsLoading(false)
        return
    }
  }


  const submitEffectiveDate = async () => {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()

    // Get date components
    var year = insurance_effective_datetime.getFullYear();
    var month = String(insurance_effective_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    var day = String(insurance_effective_datetime.getDate()).padStart(2, '0');

    // Format the string
    var dateString = `${year}-${month}-${day}`;

    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt:jwt,
      api_endpoint: "api3:portal:driver_desk",
      section: "insurance",
      request_type: "POST",
      document_name:docKey,
      method: "effectivedate",
      effective_date: dateString
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit);
        console.log(JSON.stringify(res))
        //updateRes(res);
        _hideConfirm();
        refreshPage();
        //updateIsLoading(false)
        return
    }
    catch (e) {
        const res = {status:"Error executing request",resp:[]};
        console.log(JSON.stringify(res))
        updateRes(res);
        updateIsLoading(false)
        return
    }
  }
  
  const submitExpirationDate = async () => {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()

    // Get date components
    var year = insurance_expiration_datetime.getFullYear();
    var month = String(insurance_expiration_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    var day = String(insurance_expiration_datetime.getDate()).padStart(2, '0');

    // Format the string
    var dateString = `${year}-${month}-${day}`;

    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt:jwt,
      api_endpoint: "api3:portal:driver_desk",
      section: "insurance",
      request_type: "POST",
      document_name:docKey,
      method: "expirationdate",
      expiration_date: dateString
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit);
        console.log(JSON.stringify(res))
        //updateRes(res);
        _hideConfirm();
        refreshPage();
        //updateIsLoading(false)
        return
    }
    catch (e) {
        const res = {status:"Error executing request",resp:[]};
        console.log(JSON.stringify(res))
        updateRes(res);
        updateIsLoading(false)
        return
    }
  }


  const submitCoverageType = async () => {
    if(coverageType!=='')
    {
      updateIsLoading(true)
      let session = await Auth.currentSession()      
      let accessToken = session.getAccessToken()
      let jwt = accessToken.getJwtToken()
  
      const myInit = {queryStringParameters:{ 
        back_end: process.env.REACT_APP_BACKEND,
        jwt:jwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "insurance",
        request_type: "POST",
        document_name:docKey,
        method: "coveragetype",
        coverage_type: coverageType
      }};
      //console.log(JSON.stringify(myInit))
      try {
          const res = await API.get('adminWebTools','/ago',myInit);
          console.log(JSON.stringify(res))
          //updateRes(res);
          _hideConfirm();
          refreshPage();
          //updateIsLoading(false)
          return
      }
      catch (e) {
          const res = {status:"Error executing request",resp:[]};
          console.log(JSON.stringify(res))
          updateRes(res);
          updateIsLoading(false)
          return
      }
    } else {
      console.log("error - please select a coverage type")
    }
  }



  async function _hideConfirm()
  {
    updateShowConfirmFleet(false)
    updateShowConfirmActivate(false)
    updateShowConfirmDeactivate(false)
    updateShowConfirmExpirationDate(false)
    updateShowUpdateExpirationDate(false)
    updateShowConfirmEffectiveDate(false)
    updateShowUpdateEffectiveDate(false)
    updateShowSelectCoverageType(false)
  }

  async function _showConfirm(confirmType)
  {
    switch(confirmType)
    {
      case 'fleet':
          updateConfirmLanguage("Do you attest that this insurance is valid and in place, and no fleet policies is providing insurance while this driver is driving?")
          updateShowConfirmFleet(true)
          updateShowConfirmActivate(false)
          updateShowConfirmDeactivate(false)
          updateShowConfirmExpirationDate(false)
          updateShowUpdateExpirationDate(false)
          updateShowConfirmEffectiveDate(false)
          updateShowUpdateEffectiveDate(false)
        break;
      case 'activate':
          updateConfirmLanguage("Are you sure you want to activate this insurance?")
          updateShowConfirmFleet(false)
          updateShowConfirmActivate(true)
          updateShowConfirmDeactivate(false)
          updateShowConfirmExpirationDate(false)
          updateShowUpdateExpirationDate(false)
          updateShowConfirmEffectiveDate(false)
          updateShowUpdateEffectiveDate(false)
        break;
      case 'deactivate':
        updateConfirmLanguage("Are you sure you want to deactivate this insurance?")
        updateShowConfirmFleet(false)
        updateShowConfirmActivate(false)
        updateShowConfirmDeactivate(true)
        updateShowConfirmExpirationDate(false)
        updateShowUpdateExpirationDate(false)
        updateShowConfirmEffectiveDate(false)
        updateShowUpdateEffectiveDate(false)
      break;
      case 'expirationdate':
        // Get date components
        var year = insurance_expiration_datetime.getFullYear();
        var month = String(insurance_expiration_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        var day = String(insurance_expiration_datetime.getDate()).padStart(2, '0');
        // Format the string
        var dateString = `${year}-${month}-${day}`;
        updateConfirmLanguage("Do you verify the expiration date is " + dateString + "? This must be correct. An inaccurate date could cause additional insurance costs or unwanted gaps in coverage.")
        updateShowConfirmFleet(false)
        updateShowConfirmActivate(false)
        updateShowConfirmDeactivate(false)
        updateShowConfirmExpirationDate(true)
        updateShowUpdateExpirationDate(false)
        updateShowConfirmEffectiveDate(false)
        updateShowUpdateEffectiveDate(false)
      break;
      case 'effectivedate':
        // Get date components
        var year = insurance_effective_datetime.getFullYear();
        var month = String(insurance_effective_datetime.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        var day = String(insurance_effective_datetime.getDate()).padStart(2, '0');
        // Format the string
        var dateString = `${year}-${month}-${day}`;
        updateConfirmLanguage("Do you verify the effective date is " + dateString + "? This must be correct. An inaccurate date could cause additional insurance costs or unwanted gaps in coverage.")
        updateShowConfirmFleet(false)
        updateShowConfirmActivate(false)
        updateShowConfirmDeactivate(false)
        updateShowConfirmExpirationDate(false)
        updateShowUpdateExpirationDate(false)
        updateShowConfirmEffectiveDate(true)
        updateShowUpdateEffectiveDate(false)
      break;
      default:
        updateShowConfirmFleet(false)
        updateShowConfirmActivate(false)
        updateShowConfirmDeactivate(false)
        updateShowConfirmExpirationDate(false)
        updateShowUpdateExpirationDate(false)
        updateShowConfirmEffectiveDate(false)
        updateShowUpdateEffectiveDate(false)
      break;
    }
  }



  return (
    is_loading ? <Loading /> : 
    <Flex //  https://ui.docs.amplify.aws/react/components/flex#demo
      direction="column"
    >
      <View style={{padding:"1rem"}}>
          <Flex>
            <Heading level={1}>Document {docKey}</Heading>
          </Flex>
          <Button onClick={() => refreshPage()}>
              PRESS TO GET LATEST UPDATES
          </Button>
          <Divider />
          {res ?
            res.resp ?
              res.resp[0] ?  
                <Flex direction="column">
                  <Flex wrap="wrap" justifyContent="center" gap="2rem">
                    <Flex direction="column">
                      {
                        presignedUrlView ? 
                          <View style={{ marginTop: "1rem" }}>
                            <img
                              src={presignedUrlView}
                              alt="Insurance card"
                              style={{ maxWidth: "600px", border: "1px solid #ccc", borderRadius: "8px" }}
                            />
                            <br/>
                            <Text><a href={presignedUrlView} target='_blank'>DOWNLOAD DOCUMENT</a></Text>
                          </View>
                        : undefined
                      }
                      <Divider />
                      <Heading level={2}>Document Info</Heading>
                      <View style={{maxWidth:'600px'}}>
                          <Table
                              caption=""
                              highlightOnHover={false}>
                              <TableHead>
                                  <TableRow>
                                    <TableCell as="th">Status</TableCell>
                                    <TableCell as="th">Effective Date</TableCell>
                                    <TableCell as="th">Expiration Date</TableCell>
                                    <TableCell as="th">Driver</TableCell>
                                    <TableCell as="th">Driver ID</TableCell>
                                    <TableCell as="th">Coverage Type</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  <TableRow>
                                    <TableCell>{res?.resp?.[0]?.status || "Unknown"}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.effective_date || "-"}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.expiration_date || "-"}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.driver_full_name || "N/A"}</TableCell>
                                    <TableCell>
                                      {res?.resp?.[0]?.driver_id ? (
                                        <Link to={withFleets(`../user/${res.resp[0].driver_id}`, pageFleets)}>
                                          {res.resp[0].driver_id}
                                        </Link>
                                      ) : (
                                        "-"
                                      )}
                                    </TableCell>
                                    <TableCell>{res?.resp?.[0]?.coverage_type || "N/A"}</TableCell>
                                  </TableRow>
                              </TableBody>
                          </Table>
                          <br />
                          <Heading level={3}>Scanned from the card photo</Heading>
                          <Text>
                            Model read of the image. These values are not verified.
                            Photo check is a visual guess and does not approve or deny the card.
                          </Text>
                          <Table caption="" highlightOnHover={false}>
                              <TableHead>
                                  <TableRow>
                                    <TableCell as="th">Scan</TableCell>
                                    <TableCell as="th">Card name</TableCell>
                                    <TableCell as="th">Carrier</TableCell>
                                    <TableCell as="th">Policy number</TableCell>
                                    <TableCell as="th">Effective</TableCell>
                                    <TableCell as="th">Expiration</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  <TableRow>
                                    <TableCell>{res?.resp?.[0]?.scanned_status || "—"}</TableCell>
                                    <TableCell>{scannedValue(res?.resp?.[0]?.scanned_name, res?.resp?.[0]?.scanned_name_confidence)}</TableCell>
                                    <TableCell>{scannedValue(res?.resp?.[0]?.scanned_carrier, res?.resp?.[0]?.scanned_carrier_confidence)}</TableCell>
                                    <TableCell>{scannedValue(res?.resp?.[0]?.scanned_policy_number, res?.resp?.[0]?.scanned_policy_number_confidence)}</TableCell>
                                    <TableCell>{scannedValue(res?.resp?.[0]?.scanned_effective_date, res?.resp?.[0]?.scanned_effective_date_confidence)}</TableCell>
                                    <TableCell>{scannedValue(res?.resp?.[0]?.scanned_expiration_date, res?.resp?.[0]?.scanned_expiration_date_confidence)}</TableCell>
                                  </TableRow>
                              </TableBody>
                          </Table>
                          <Table caption="" highlightOnHover={false}>
                              <TableHead>
                                  <TableRow>
                                    <TableCell as="th">Legible</TableCell>
                                    <TableCell as="th">Unreadable reason</TableCell>
                                    <TableCell as="th">Photo check</TableCell>
                                    <TableCell as="th">Photo check notes</TableCell>
                                    <TableCell as="th">Reader</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  <TableRow>
                                    <TableCell>{legibleLabel(res?.resp?.[0]?.scanned_legible)}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.scanned_unreadable_reason || "—"}</TableCell>
                                    <TableCell>{(res?.resp?.[0]?.scanned_photo_check || "—").replace(/_/g, " ")}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.scanned_photo_check_notes || "—"}</TableCell>
                                    <TableCell>{res?.resp?.[0]?.scanned_reader || "—"}</TableCell>
                                  </TableRow>
                              </TableBody>
                          </Table>
                          <br />
                          {
                            /*
                            res?.resp?.[0]?.status === "active" ?
                              showConfirmDeactivate ?
                                <View>
                                  <Heading level={4}>De-Activate Personal Insurance</Heading>
                                  <Text>{confirmLanguage}</Text>
                                  <br/>
                                  <Button onClick={() => deactivate()}>
                                    Confirm
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button onClick={() => _hideConfirm()}>
                                    Cancel
                                  </Button>
                                </View>
                              :
                                <View>
                                  <Button onClick={() => _showConfirm("deactivate")}>
                                    De-Activate
                                  </Button>
                                </View>
                            :
                              showConfirmActivate ?
                                <View>
                                  <Heading level={4}>Activate Personal Insurance</Heading>
                                  <Text>{confirmLanguage}</Text>
                                  <br/>
                                  <Button onClick={() => activate()}>
                                    Confirm
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button onClick={() => _hideConfirm()}>
                                    Cancel
                                  </Button>
                                </View>
                              :
                                <View>
                                  <Button onClick={() => _showConfirm("activate")}>
                                    Activate
                                  </Button>
                                </View>
                              */
                          }
                          <br/>
                          {
                            showSelectCoverageType ?
                            <View>
                              <Divider />
                              <SelectField
                                label="Coverage Type"
                                descriptiveText="Select the type of coverage provided..."
                                value={coverageType}
                                onChange={(e) => updateCoverageType(e.target.value)}
                              >
                                <option value="">--Please Select--</option>
                                <option value="physical">Physical Damage</option>
                                <option value="liability">Liability</option>
                                <option value="both">Both</option>
                              </SelectField>
                              <br/>
                              <br/>
                              <Button onClick={() => submitCoverageType()}>
                                Submit
                              </Button>
                              <br />
                              <br />
                              <Button onClick={() => _hideConfirm()}>
                                Cancel
                              </Button>
                              <br/>
                              <br/>
                              <Divider />
                            </View>
                            : 
                            <View>
                              <Button onClick={() => updateShowSelectCoverageType(true)}>
                                Update Coverage Type
                              </Button>
                            </View>
                          }
                          <br/>
                          {
                            showConfirmEffectiveDate ? 
                              <View>
                                <Divider />
                                <Heading level={4}>Update Effective Date</Heading>
                                <Text>{confirmLanguage}</Text>
                                <br/>
                                <br/>
                                <Button onClick={() => submitEffectiveDate()}>
                                  Submit
                                </Button>
                                <br />
                                <br />
                                <Button onClick={() => _hideConfirm()}>
                                  Cancel
                                </Button>
                                <br/>
                                <br/>
                                <Divider />
                              </View>
                            :
                            showUpdateEffectiveDate ?
                              <View>
                                <Divider />
                                <Heading level={4}>Update Effective Date</Heading>
                                <Text>Please select the new effective date.</Text>
                                <br/>
                                <DatePicker
                                  name="Effective Date"
                                  selected={insurance_effective_datetime}
                                  onChange={(date) => updateEffectiveDate(date)}
                                  showTimeSelect={false}
                                  dateFormat="yyyy-MM-dd"
                                  timeIntervals={60}
                                />
                                <br/>
                                <br/>
                                <Button onClick={() => _showConfirm("effectivedate")}>
                                  Submit
                                </Button>
                                <br />
                                <br />
                                <Button onClick={() => _hideConfirm()}>
                                  Cancel
                                </Button>
                                <br/>
                                <br/>
                                <Divider />
                              </View>
                            :
                            <View>
                              <Button onClick={() => updateShowUpdateEffectiveDate(true)}>
                                Update Effective Date
                              </Button>
                            </View>
                          }
                          <br/>
                          {
                            showConfirmExpirationDate ? 
                              <View>
                                <Divider />
                                <Heading level={4}>Update Expiration Date</Heading>
                                <Text>{confirmLanguage}</Text>
                                <br/>
                                <br/>
                                <Button onClick={() => submitExpirationDate()}>
                                  Submit
                                </Button>
                                <br />
                                <br />
                                <Button onClick={() => _hideConfirm()}>
                                  Cancel
                                </Button>
                                <br />
                                <br/>
                                <Divider />
                              </View>
                            :
                            showUpdateExpirationDate ?
                              <View>
                                <Divider />
                                <Heading level={4}>Update Expiration Date</Heading>
                                <Text>Please select the new expiration date.</Text>
                                <br/>
                                <DatePicker
                                  name="Expiration Date"
                                  selected={insurance_expiration_datetime}
                                  onChange={(date) => updateExpirationDate(date)}
                                  showTimeSelect={false}
                                  dateFormat="yyyy-MM-dd"
                                  timeIntervals={60}
                                />
                                <br/>
                                <br/>
                                <Button onClick={() => _showConfirm("expirationdate")}>
                                  Submit
                                </Button>
                                <br />
                                <br />
                                <Button onClick={() => _hideConfirm()}>
                                  Cancel
                                </Button>
                                <br/>
                                <br/>
                                <Divider />
                              </View>
                            :
                            <View>
                              <Button onClick={() => updateShowUpdateExpirationDate(true)}>
                                Update Expiration Date
                              </Button>
                            </View>
                          }
                      </View>
                      <Divider />
                      <Heading level={2}>Fleet Sign-Off</Heading>
                      {
                        res?.resp?.[0]?.signed_off_fleet_user_id > 0 ? 
                          <View style={{maxWidth:'600px'}}>
                              <Table
                                  caption=""
                                  highlightOnHover={false}>
                                  <TableHead>
                                      <TableRow>
                                        <TableCell as="th">Fleet Sign-Off User Name</TableCell>
                                        <TableCell as="th">Fleet Sign-Off User ID</TableCell>
                                        <TableCell as="th">Fleet Sign-Off Timestamp</TableCell>
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      <TableRow>
                                        <TableCell>{res?.resp?.[0]?.signed_off_fleet_full_name || "N/A"}</TableCell>
                                        <TableCell>{res?.resp?.[0]?.signed_off_fleet_user_id ?? "-"}</TableCell>
                                        <TableCell>{res?.resp?.[0]?.signed_off_fleet_timestamp || "Not signed"}</TableCell>
                                      </TableRow>
                                  </TableBody>
                              </Table>
                          </View>
                        : showConfirmFleet ? 
                          <View>
                            <Divider />
                            <Heading level={4}>Complete Fleet Sign-Off</Heading>
                            <Text>{confirmLanguage}</Text>
                            <br/>
                            <Button onClick={() => signOffFleet()}>
                              Confirm
                            </Button>
                            <br/>
                            <br/>
                            <Button onClick={() => _hideConfirm()}>
                              Cancel
                            </Button>
                            <br />
                            <br/>
                            <Divider />
                          </View>
                        :
                          <View>
                            <Text>The fleet has not yet signed-off on the use of this document.</Text>
                            <br />
                            <Button onClick={() => _showConfirm("fleet")}>
                              Complete Fleet Sign-Off
                            </Button>
                          </View>
                      }
                    </Flex>
                  </Flex>
                  <Divider />
                  {
                    showDataPacket ?
                      <Flex direction="column">
                        <Heading level={2}>Data Packet</Heading>
                        <pre id="json"><p>{JSON.stringify(res,null, 4)}</p></pre>
                        <Button onClick={() => updateShowDataPacket(false)}>
                          Hide Data Packet
                        </Button>
                      </Flex>
                    : 
                      <Button onClick={() => updateShowDataPacket(true)}>
                        Document Data Packet
                      </Button>
                  }
                  <br/><br/><br/><br/>
                </Flex>
              : undefined
            : undefined
          : undefined}
          
      </View>
    </Flex>
  );
}